import {useContext, useEffect, useState} from "react";
import {RealmContext, TokenContext} from "../Store";
import React, { lazy, Suspense } from 'react';
// import SwaggerUI from "swagger-ui-react";
import {trackPromise} from "react-promise-tracker";
// import BimetaDataService from "../../services/BimetaDataService";
import http from "../../shared/http-common";
import {useParams} from "react-router";

const SwaggerUI = lazy(() => import('swagger-ui-react'));

function DokuObject() {
    // const [treeItemsState] = useContext(TreeItemsStateContext);
    const [token] = useContext(TokenContext);
    const [realm] = useContext(RealmContext);
    const { openApiJsonFile } = useParams()
    // // const [SiteColor] = useContext(SiteColorContext);
    // const [bimProfileSelected, setBimProfileSelected] = useContext(BimProfileSelectedContext);
    const [spec, setSpec] =  useState(null);
    const [, setIsLoading] = useState(false);

    const getApiDoc = async(openApiJsonFile) => {
        console.log('openApiJsonFile2: ' + openApiJsonFile)
        return await trackPromise(
            getdocfromserver(token, realm, openApiJsonFile)
        )
    }

    const getdocfromserver = (token, realm, openApiJsonFile) => {
        let formData = new FormData();
        formData.append("realm", realm);
        formData.append("openApiJsonFile", openApiJsonFile);
        console.log('openApiJsonFile3: ' + openApiJsonFile)
        console.dir(formData)
        return http.post(`/oaf/${realm}/api4`, formData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            }
        });
    }
    useEffect(() => {
        setIsLoading(true)
        console.log('openApiJsonFile: ' + openApiJsonFile)
        getApiDoc(openApiJsonFile).then(data => {
            setSpec(data.data);
            setIsLoading(false)
        })
    }, [openApiJsonFile]);

    return (
        <>
            <div style={{textAlign: "left"}}>
                <Suspense fallback={<div>Loading...</div>}>
                    <SwaggerUI spec={spec} ></SwaggerUI>
                </Suspense>
            </div>
        </>
    )
}
export default DokuObject;
